<template>
  <div class="w-100 h-100 bg-white">
    <div class="d-flex p-1">
      <button
        @click="setVendorPermalink(initialVendor ? initialVendor.permalink : '')"
        class="hd-SearchField_ButtonMobile"
        type="button"
      >
        <SearchIcon class="svg-24 svg-fill-dark" />
      </button>
      <input
        ref="mobileInput"
        @input="changeCurrentValue"
        :value="currentValue"
        :placeholder="placeholder"
        @keydown.enter="setVendorPermalink(initialVendor ? initialVendor.permalink : '')"
        autocomplete="off"
        type="text"
        name="keywords"
        class="form-control hd-SearchField_InputMobile"
      />
      <button @click="triggerSearchOverlay" class="hd-SearchField_ButtonMobile" type="button">
        <CloseIcon class="svg-24 svg-fill-dark" />
      </button>
    </div>
    <div v-if="currentValue" class="pt-1 px-1">
      <button
        @click="setVendorPermalink(initialVendor.permalink)"
        v-if="initialVendor"
        class="btn btn-reset btn-sm mobile-search-item"
      >
        {{ currentValue }}
        <span class="font-weight-normal">{{ t.vendor_search }}</span>
      </button>
      <button @click="setVendorPermalink('')" class="btn btn-reset btn-sm mobile-search-item">
        {{ currentValue }}
        <span class="font-weight-normal">{{ t.all_search }}</span>
      </button>
      <div v-if="suggestions" class="d-flex flex-column">
        <div :key="i" v-for="(group, i) of suggestions" class="d-flex flex-column">
          <button
            :key="suggestion.permalink"
            v-for="suggestion of group.data"
            @click="selectSuggestion(suggestion)"
            type="button"
            class="btn btn-reset btn-sm mobile-search-item"
          >
            <img :src="suggestion.images[0].url" class="rounded hd-SearchField_ResultImage" />
            <span class="font-weight-normal">{{ getSuggestionValue(suggestion) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchIcon from "../../icons/atalanda/search.svg";
import CloseIcon from "../../icons/atalanda/close.svg";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Searchbar",
  components: {
    SearchIcon,
    CloseIcon,
  },
  props: {
    t: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    currentValue: {
      type: String,
      required: false,
      default: "",
    },
    suggestions: {
      type: Array,
      required: false,
      default: () => [],
    },
    initialVendor: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      currentLocale: "getCurrentLocale",
    }),
  },
  mounted() {
    this.$refs.mobileInput.focus();
  },
  methods: {
    ...mapActions({ toggleSearchState: "toggleSearchState" }),
    triggerSearchOverlay() {
      this.toggleSearchState();
    },
    setVendorPermalink(permalink) {
      this.$emit("setVendorPermalink", permalink);
    },
    changeCurrentValue(e) {
      this.$emit("changeCurrentValue", e.target.value);
    },
    selectSuggestion(item) {
      this.$emit("select", { item });
    },
    getSuggestionValue(suggestion) {
      return suggestion.name[this.currentLocale] || suggestion.name.de;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.hd-SearchField_ButtonMobile {
  border: none;
  box-shadow: none;
  border-radius: 0;
  background: none;
  min-width: 45px;
  padding: 0;

  &:focus {
    outline: none;
    background-color: $gray-200;
  }
}

.mobile-search-item {
  padding: $spacer-1 $spacer-2;
  border-radius: $border-radius;
  width: 100%;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-shadow: none;

  &:hover,
  &:focus {
    box-shadow: none;
    background: $gray-200;
  }
}
</style>
